import { apiSlice } from "app/api/apiSlice";

export const CBBOApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCBBOLeadsList: builder.query({
      query: (pagination) => `/api/v1/onboarding/farmer-groups/CBBO/leads`,
    }),
    getCBBOLeadsById: builder.query({
      query: (id) => `/api/v1/onboarding/farmer-groups/CBBO/leads/${id}`,
    }),
  
    getCBBOList: builder.query({
      query: ({ pagination, searchKey }) =>
        `/api/v1/onboarding/farmer-groups/CBBO?q=${searchKey?searchKey:""}`,
    }),
    getCBBOById: builder.query({
      query: (id) => `/api/v1/onboarding/farmer-groups/CBBO/${id}`,
    }),
    createCBBO: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/onboarding/farmer-groups/CBBO",
        method: "POST",
        body: payload,
      }),
    }),
    getCBBOUserList: builder.query({
      query: (id) => `/api/v1/onboarding/farmer-groups/CBBO/${id}/users`,
    }),
    createCBBOUser: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/farmer-groups/CBBO/${id}/users`,
        method: "POST",
        body: payload,
      }),
    }),
    updateCbboById: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/farmer-groups/CBBO/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),

    CBBOtakeAction: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/organizations/leads/${id}/take-action`,
        method: "PUT",
        body: payload,
      }),
    }),
    getCBBOallMediabyId: builder.query({
      query: (id) => `/api/v1/onboarding/farmer-groups/CBBO/${id}/media`,
    }),
    updateCbboLeadById: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/onboarding/farmer-groups/CBBO/${id}`,
        method: "PATCH",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetCBBOLeadsListQuery,
  useGetCBBOLeadsByIdQuery,
  useUpdateCBBOLeadByIdMutation,
  useGetCBBOListQuery,
  useGetCBBOByIdQuery,
  useCreateCBBOMutation,
  useGetCBBOUserListQuery,
  useCreateCBBOUserMutation,
  useCBBOtakeActionMutation,
  useGetCBBOallMediabyIdQuery,useUpdateCbboLeadByIdMutation
} = CBBOApiSlice;
